import React, {useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {Menu} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import SettingsMenu from "../settingsMenu";
import MenuOpenOutlinedIcon from '@material-ui/icons/MenuOpenOutlined';
import usePersistentStore from "../../../persistentStore";

const inIFrame = (window.parent.window !== window);

const useStyles = makeStyles(theme => ({
    buttonCollapse: {
        [theme.breakpoints.up("md")]: {
            display: "none"
        },
        margin: "10px",
        boxShadow: "none"
    },
    iconStyle: {
        color: 'white',
    }
}));

const ButtonMenuBarCollapse = props => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState();
    const open = Boolean(anchorEl);
    const [globalPersistentState] = usePersistentStore();

    const handleMenu = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className={classes.buttonCollapse}>
            {!inIFrame && <>
                <IconButton onClick={handleMenu}>
                    <MenuOpenOutlinedIcon className={classes.iconStyle}/>
                </IconButton>
                <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right"
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "left"
                    }}
                    open={open}
                    onClose={handleClose}
                >
                    {props.children}
                </Menu>
            </>}
            {inIFrame && globalPersistentState.me && <SettingsMenu/>}
        </div>
    );
};

export default ButtonMenuBarCollapse;
